import * as React from "react";
import type { SVGProps } from "react";
const SvgUpload01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M4.555 16.556c-1.948 0-3.526-1.329-3.526-3.276a3.527 3.527 0 0 1 3.918-3.505v-.022h.048a6.27 6.27 0 0 1 11.685-3.86 5.486 5.486 0 0 1 6.29 5.427c.001 2.494-1.663 4.396-3.941 5.022M11.827 21.3v-9m0 0-3.598 3.712m3.598-3.712 3.602 3.712"
    />
  </svg>
);
export default SvgUpload01;
